"use strict";

import axios from "axios";
const OPENBD_V1_URL = "https://api.openbd.jp/v1/";

const getBookInfo = async (isbn) => {
  let bookInfo = {};
  try {
    const openbdResponse = await axios.get(OPENBD_V1_URL + "get?isbn=" + isbn);
    bookInfo = openbdResponse.data[0].summary;
    return bookInfo;
  } catch {
    return bookInfo;
  }
};

export { getBookInfo };